<!--
     <CentroProcessesmatrix
       :centros="centros"
       @action_new="action_new"
       @action_edit="action_edit"
       @action_delete="action_delete"
     />
-->

<template>
  <div class="ca-layout">
    <div class="ca-sub-header">
      <v-text-field
        v-model="filter_centro"
        dense filled outlined clearable color="primary"
        label="Buscar centro"
      />

      <v-text-field
        v-model="filter_process"
        dense filled outlined clearable color="primary"
        label="Buscar proceso"
      />

      <v-autocomplete
        v-model="select_standard"
        :items="standard_list"
        dense filled outlined clearable color="primary"
        label="Estándar del proceso"
      />

      <v-autocomplete
        v-model="select_type"
        :items="processtype_list"
        dense filled outlined clearable color="primary"
        label="Tipo del proceso"
      />
    </div>

    <div class="ca-matrixcont">
      <div class="ca-explain">
        <div>
          Los procesos son globales para una empresa. Los centros en un mimso proceso comparten datos y los usuarios con roles en ambos centros pueden ver los datos mediante el filtro "multicentro" del explorador.
        </div>
      </div>
      <ManyToManyMatrix
        :cols="centro_list"
        :rows="processes_list"
        @cellclick="toggle_centro_proc"
        @row_click="modify_process"
        @col_click="modify_centro"
        column_name="Centro"
        row_name="Proceso"
        ref="m2mm"
      />
    </div>
    <ModalDialogForm
      :title="modal_title"
      :showModalDialog="show_modal"
      :fields_to_collect="fields_to_collect"
      clear_button_text="Cancelar"
      submit_button_text="Guardar"
      validate
      @close-dialog="hide_dialog"
      @clear="hide_dialog"
      @submit="submit_funct"
    />
  </div>
</template>


<style lang="scss">
 @import "@/sass/centroadmin.scss";
</style>


<script>
 import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
 import QCentro from '@/api/QCentro';
 import QProcess from '@/api/Process';
 import ManyToManyMatrix from '@/components/ManyToManyMatrix';
 import ModalDialogForm from '@/components/explorer/ModalDialog';

 export default {
   name: 'CentroProcessesmatrix',

   components: {
     ManyToManyMatrix,
     ModalDialogForm,
   },

   props: {
     centros: {required: true},
   },

   data: () => ({
     filter_centro: '',
     filter_process: '',
     select_standard: null,
     select_type: null,

     modal_title: '',
     show_modal: false,
     fields_to_collect: null,
     submit_funct: () => {},

   }),

   computed: {
     ...mapGetters(['site_id']),
     ...mapState(['processes']),

     centro_list() {
       const search = (this.filter_centro || '').toLowerCase();
       return (
         (Object.values(this.centros) || [])
           .map(c => ({
             value: c.id,
             text: c.name,
             tooltip: c.path_str,
             rows: new Set(c.processes),
           }))
           .filter(c => !search || c.tooltip.toLowerCase().indexOf(search) >= 0)
       );
     },

     processes_list() {
       const proc_pathify = (path_str) => (
         path_str
           .split('/')
           .map(pid => (this.processes[pid] === undefined ? ''+pid : this.processes[pid].name))
           .join('/')
       );
       console.log(this.processes);
       const search = (this.filter_process || '').toLowerCase();
       return (
         (Object.values(this.processes) || [])
           .filter(p => !this.select_standard || p.standard == this.select_standard)
           .filter(p => !this.select_type     || p.process_type == this.select_type)
           .map(proc => ({
             value: proc.id,
             text: proc.name,
             tooltip: proc_pathify(`${proc.path}/${proc.id}`),
           }))
           .filter(p => !search || p.tooltip.toLowerCase().indexOf(search) >= 0)
       );
     },

     standard_list() {
       const done_ids = {};
       return (Object
         .values(this.processes || {})
         .filter(x => !!(done_ids[x.standard] = true))
         .map(p => ({
           value: p.standard,
           text: p.standard_name,
         }))
         .filter(i => !!i.value)
       );
     },

     processtype_list() {
       const done_ids = {};
       return (Object
         .values(this.processes || {})
         .filter(x => !!(done_ids[x.process_type] = true))
         .map(p => ({
           value: p.process_type,
           text: p.get_process_type_display,
         }))
         .filter(i => !!i.value)
       );
     }
   },

   methods: {
     ...mapActions(['UPDATE_CENTRO_ACTION','GET_CENTROS']),

     async toggle_centro_proc(centro_id, proc_id) {
       this.$refs.m2mm.set_loading(centro_id, proc_id, true);

       const check = this.centros[centro_id].processes.indexOf(proc_id) >= 0;
       const api_method = check ? QCentro.remove_process : QCentro.add_process;
       const new_centro = await api_method(this.site_id, centro_id, proc_id);
       this.UPDATE_CENTRO_ACTION(new_centro);

       this.$refs.m2mm.set_loading(centro_id, proc_id, false);
     },

     modify_centro(centro) {
      if (!centro) return;
      this.fields_to_collect = [
          [
            {
              id: 'centro',
              label: "Centro",
              required: true,
              value: centro.value,
              readonly: true,
              cols: 4,
              class: null,
              component: 'Select',
              placeholder: "",
              items: [[centro.value,centro.text]]
            },
            {
              id: 'processes',
              label: "Processos",
              required: false,
              value: Array.from(centro.rows),
              readonly: false,
              cols: 8,
              class: null,
              component: 'AutocompleteSelect',
              placeholder: "",
              items: this.processes_list.map(it => ([it.value,it.text])),
              multiple: true,
              chips: true,
            },
          ]
         ];
      this.submit_funct = this.update_centro;
      this.show_modal = true;
     },

     modify_process(process) {
      if (!process) return;
      this.fields_to_collect = [
        [
          {
            id: 'process',
            label: "Proceso",
            required: true,
            value: process.value,
            readonly: true,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: "",
            items: [[process.value,process.text]]
          },
          {
            id: 'centros',
            label: "Centros",
            required: false,
            value: this.centro_list.filter(it => it.rows.has(process.value)).map(it => it.value),
            readonly: false,
            cols: 8,
            class: null,
            component: 'AutocompleteSelect',
            placeholder: "",
            items: this.centro_list.map(it => ([it.value,it.text])),
            multiple: true,
            chips: true,
          },
        ],
        [
          {
            id: 'warning1',
            label: "This process will just be added to the centers without it. It will not be removed from anyone.",
            required: false,
            value: "",
            readonly: true,
            hidden: null,
            cols: 6,
            class: 'warning',
            component: 'Tag',
            placeholder: '',
          }
        ]
      ];
      this.submit_funct = this.update_process;
      this.show_modal = true;
     },


     hide_dialog() {
      this.show_modal = false;
     },

     update_centro(form) {
      const centro = form.get('centro');
      const processes = JSON.parse(form.get('processes'));

      QCentro.modify_centro_processes(this.site_id, centro, processes).then((new_centro)=>{
        this.hide_dialog();
        this.UPDATE_CENTRO_ACTION(new_centro);
      });
     },

     update_process(form) {
      const process = +form.get('process');
      const centros = JSON.parse(form.get('centros'));

      QCentro.apply_process_to_centros(this.site_id, process, centros).then(()=>{
        this.hide_dialog();
        // Update centros with the selected process
        for(let centro_id of centros) {
          let centro = this.centros[centro_id];
          if (centro && !(centro.processes || []).includes(process)) {
            centro.processes = [...centro.processes,process];
            this.UPDATE_CENTRO_ACTION({...centro});
          }
        }
      });
     },
   },
 }
</script>
